import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const cardContent: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  '&.MuiCardContent-root:last-child': { paddingBottom: 1 },
};
